import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { OVERLAY_PANEL_DATA } from 'src/app/core/services/overlay-panel';
import { TravellersTransformerPipe } from '../trip-wizard/travellers-transformer.pipe';
import { OverlayPanelRef } from 'src/app/core/services/overlay-panel/overlay-panel-ref';

import { TravelersSettingComponent } from '../travelers-setting/travelers-setting.component';

@Component({
  selector: 'app-travelers-panel',
  templateUrl: './travelers-panel.component.html',
  styleUrl: './travelers-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, TravelersSettingComponent],
  providers: [TravellersTransformerPipe],
})
export class TravelersPanelComponent {
  public panelData = inject(OVERLAY_PANEL_DATA);
  public preparedPayload: any;
  #overlayPanelRef = inject(OverlayPanelRef);

  public submitPanel(): void {
    const payload = this.preparedPayload;
    this.#overlayPanelRef.emitValue(payload);
    this.#overlayPanelRef.close();
  }

  public emittedValuesHandler(payload: any): void {
    this.preparedPayload = payload;
  }
}
